import { render, staticRenderFns } from "./WidgetPlatinumPlanBanner.vue?vue&type=template&id=4b05a5c1&scoped=true"
import script from "./WidgetPlatinumPlanBanner.vue?vue&type=script&lang=js"
export * from "./WidgetPlatinumPlanBanner.vue?vue&type=script&lang=js"
import style0 from "./WidgetPlatinumPlanBanner.vue?vue&type=style&index=0&id=4b05a5c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b05a5c1",
  null
  
)

export default component.exports